import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.sort";
//
//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
export default {
  props: {
    width: {
      type: String,
      default: '500px'
    },
    height: {
      type: String,
      default: '380px'
    },
    top: {
      type: String,
      default: '12px'
    }
  },
  data: function data() {
    return {
      chart: 'chart10'
    };
  },
  mounted: function mounted() {// setTimeout(() => {
    // 	this.initBarChart()
    // }, 1000)
    // this.$nextTick(() => {})
  },
  methods: {
    initBarChart: function initBarChart(dataArr) {
      var data = dataArr;
      var data = data.sort(function (a, b) {
        return b.value - a.value;
      });
      var max = 150; // var max = Math.max(...data.map(item => item.value))

      var len = Math.ceil(data.length / 2);
      var otherLen = data.length - len;
      var data1 = data.slice(0, len);
      var data2 = data.slice(len);
      var option = {
        // backgroundColor: 'rgba(0,0,0,.5)',
        color: '#409EFF',
        legend: {
          right: 10
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: [{
          x: '5%',
          y: '5%',
          width: '40%',
          height: '80%' // containLabel: true

        }, {
          x2: '5%',
          y: '5%',
          width: '40%',
          height: '80%' // containLabel: true

        }],
        yAxis: [{
          type: 'category',
          gridIndex: 0,
          axisLine: {
            show: 0
          },
          axisLabel: {
            verticalAlign: 'bottom',
            align: 'left',
            padding: [0, 0, 5, 10],
            color: '#0ff',
            fontSize: '16',
            // formatter: (p, index) => {
            // 	return '{index|' + (index + 1) + '} ' + p
            // },
            rich: {
              index: {
                color: '#26BCFF',
                fontSize: '20',
                fontWeight: 'bold'
              }
            }
          },
          axisTick: {
            show: 0
          },
          inverse: true,
          data: data1.map(function (item) {
            return item.name;
          })
        }, {
          type: 'category',
          gridIndex: 0,
          axisLine: {
            show: 0
          },
          axisLabel: {
            verticalAlign: 'bottom',
            align: 'right',
            padding: [0, 0, 0, 0],
            textStyle: {
              color: '#26BCFF',
              fontSize: '20'
            },
            formatter: function formatter(params) {
              return '{num|' + params + '}';
            },
            rich: {
              num: {
                color: '#FF982E',
                fontSize: '20',
                fontWeight: 'bold'
              }
            }
          },
          axisTick: {
            show: 0
          },
          inverse: true,
          data: data1.map(function (item) {
            return item.value;
          })
        }, {
          type: 'category',
          gridIndex: 1,
          axisLine: {
            show: 0
          },
          axisLabel: {
            verticalAlign: 'bottom',
            align: 'left',
            padding: [0, 0, 5, 10],
            color: '#0ff',
            fontSize: '16',
            // formatter: (p, index) => {
            // 	return '{index|' + (index + len + 1) + '} ' + p
            // },
            rich: {
              index: {
                color: '#26BCFF',
                fontSize: '20',
                fontWeight: 'bold'
              }
            }
          },
          axisTick: {
            show: 0
          },
          inverse: true,
          data: data2.map(function (item) {
            return item.name;
          })
        }, {
          type: 'category',
          gridIndex: 1,
          axisLine: {
            show: 0
          },
          axisLabel: {
            verticalAlign: 'bottom',
            align: 'right',
            padding: [0, 0, 0, 0],
            textStyle: {
              color: '#26BCFF',
              fontSize: '20'
            },
            formatter: function formatter(params) {
              return '{num|' + params + '}';
            },
            rich: {
              num: {
                color: '#FF982E',
                fontSize: '20',
                fontWeight: 'bold'
              }
            }
          },
          axisTick: {
            show: 0
          },
          inverse: true,
          data: data2.map(function (item) {
            return item.value;
          })
        }],
        xAxis: [{
          show: 0,
          type: 'value',
          gridIndex: 0,
          max: max,
          axisLine: {
            show: 0
          },
          axisTick: {
            show: 0
          },
          splitLine: {
            show: 0
          }
        }, {
          show: 0,
          gridIndex: 1,
          max: max,
          type: 'value',
          axisLine: {
            show: 0
          },
          axisTick: {
            show: 0
          },
          splitLine: {
            show: 0
          }
        }],
        series: [{
          type: 'bar',
          barWidth: 5,
          xAxisIndex: 0,
          yAxisIndex: [0, 1],
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
              offset: 0,
              color: '#72AEFF' // 0% 处的颜色

            }, {
              offset: 1,
              color: '#0084FF' // 100% 处的颜色

            }], false),
            barBorderRadius: 5
          },
          showBackground: true,
          backgroundStyle: {
            color: '#263877',
            barBorderRadius: 5
          },
          data: data1
        }, {
          type: 'bar',
          barWidth: 5,
          xAxisIndex: 1,
          yAxisIndex: [2, 3],
          itemStyle: {
            barBorderRadius: 5
          },
          showBackground: true,
          backgroundStyle: {
            color: '#263877',
            barBorderRadius: 5
          },
          data: data2
        }]
      }; // background-image: linear-gradient(0deg, rgba(34,115,135,0.46) 0%, #3DE2ED 100%);

      var chart = this.$refs[this.chart];
      var myChart = this.$echarts.init(chart);
      myChart.setOption(option);

      window.onresize = function () {
        myChart.resize();
      };
    }
  }
};